import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button, Input, Row, Text } from "@nextui-org/react";
import classNames from "classnames";
import { FieldArray, useField } from "formik";
import React, { useCallback, useState } from "react";
import { Icon } from "../../fa-icon";
import styles from "./text-list.module.less";
export var TextList = function TextList(_ref) {
  var _field$value;

  var inline = _ref.inline,
      label = _ref.label,
      name = _ref.name;

  var _useField = useField(name),
      _useField2 = _slicedToArray(_useField, 1),
      field = _useField2[0];

  var values = (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : [];

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var onInputChange = useCallback(function (e) {
    setInputValue(e.target.value);
  }, []);
  return /*#__PURE__*/React.createElement(FieldArray, {
    name: name,
    render: function render(arrayHelpers) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrapper
      }, label && /*#__PURE__*/React.createElement(Text, {
        color: "primary",
        size: "xs"
      }, label), /*#__PURE__*/React.createElement("ul", {
        className: classNames(styles.list, inline && styles.inline)
      }, values.map(function (value, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index
        }, /*#__PURE__*/React.createElement(Text, {
          size: "xs",
          color: "primary"
        }, value), /*#__PURE__*/React.createElement(Button, {
          auto: true,
          light: true,
          className: styles.action,
          size: "xs",
          onClick: function onClick() {
            return arrayHelpers.remove(index);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "xmark"
        })));
      })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Input, {
        onChange: onInputChange,
        status: "primary"
      }), /*#__PURE__*/React.createElement(Button, {
        auto: true,
        onClick: function onClick() {
          arrayHelpers.push(inputValue);
          setInputValue("");
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "plus"
      }))));
    }
  });
};